module.exports = __webpack_public_path__ + "static/app-store-96c8746fd0feb88aaceed2fb3f4c7259.svg";